import { IonButton, IonButtons, IonIcon, IonText } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useState } from 'react';
import TecladoVirtual from './TecladoVirtual';

interface Props {
    onNext: (nome: string) => void;
    onPular: () => void;
    onBack: () => void;
}

const TelaIdentificacao: React.FC<Props> = ({ onNext, onPular, onBack }) => {
    const [nome, setNome] = useState('');

    return (
        <div className="totem-tela-identificacao">
            <div className="totem-tela-header">
                <IonButtons>
                    <IonButton fill="clear" color="medium" onClick={onBack} className="totem-btn-voltar">
                        <IonIcon icon={arrowBack} slot="icon-only" />
                    </IonButton>
                </IonButtons>
            </div>

            <div className="totem-tela-body">
                <h2>Como podemos te chamar?</h2>
                <p>Digite seu nome para personalizar o pedido</p>

                <div className="totem-input-display" style={{ width: '100%', maxWidth: 'calc(10 * 60px + 9 * 4px)', marginLeft: 'auto', marginRight: 'auto' }}>
                    <IonText color="dark">
                        <h2 style={{ margin: 0, fontSize: '1.2rem', wordBreak: 'break-all' }}>{nome || ''}</h2>
                    </IonText>
                </div>

                <TecladoVirtual
                    value={nome}
                    onChange={setNome}
                    maxLength={30}
                />


            </div>
            <div className="totem-tela-actions">
                <IonButton
                    className="totem-btn"
                    expand="block"
                    color="totem"
                    disabled={!nome.trim()}
                    onClick={() => onNext(nome.trim())}
                >
                    Continuar
                </IonButton>
                {/* <IonButton
                        expand="block"
                        size="large"
                        fill="outline"
                        color="medium"
                        onClick={onPular}
                    >
                        Pular
                    </IonButton> */}
            </div>
        </div>
    );
};

export default TelaIdentificacao;
